import React from "react";
import "./Downloads.css";

const files = [
  { label: "Checkliste Wärmeplanung", path: "./assets/Checkliste_Wärmeplanung.pdf" },
  { label: "Handbuch Wärmeplanung", path: "/assets/Handbuch_Wärmeplanung.pdf" },
  { label: "Leitfaden Wärmeplanung", path: "./assets/Leitfaden_Wärmeplanung.pdf" },
  { label: "Technikkatalog", path: "./assets/Technikkatalog.pdf" },
  { label: "Wärmeplanung Bayern", path: "./assets/Wärmeplanung_Bayern.pdf" },
  { label: "Wärmeplanungsgesetz", path: "./assets/Wärmeplanungsgesetz.pdf" }
];

const Downloads: React.FC = () => (
  <section>
    <div className="container">
      <h2 className="page-heading">Downloads</h2>
      <div className="download-buttons">
        {files.map((f) => (
          <a key={f.path} href={f.path} download className="download-link">
            {f.label}
          </a>
        ))}
      </div>
    </div>
  </section>
);

export default Downloads;
